// extracted by css-extract-rspack-plugin
var _1 = "DCe5YGGpsIlpjoPy";
var _2 = "A2FN6qtbjdkBbK6O";
var _3 = "Fg8JZiH02PkQpAax";
var _4 = "LPnUQnRnB9I7GglM";
var _5 = "Ur1tHp58c82vY2vk";
var _6 = "wJFAmRgwt8cuicHG";
var _7 = "S6XSCLh914orar_T";
export { _1 as "title", _2 as "titleActive", _3 as "titleFullWidth", _4 as "titleSizeDefault", _5 as "titleSizeSmall", _6 as "titleVariantContained", _7 as "titleVariantDefault" }
// extracted by css-extract-rspack-plugin
var _1 = "DCe5YGGpsIlpjoPy";
var _2 = "A2FN6qtbjdkBbK6O";
var _3 = "Fg8JZiH02PkQpAax";
var _4 = "LPnUQnRnB9I7GglM";
var _5 = "Ur1tHp58c82vY2vk";
var _6 = "wJFAmRgwt8cuicHG";
var _7 = "S6XSCLh914orar_T";
export { _1 as "title", _2 as "titleActive", _3 as "titleFullWidth", _4 as "titleSizeDefault", _5 as "titleSizeSmall", _6 as "titleVariantContained", _7 as "titleVariantDefault" }
